import React from 'react';
import './Career.css';

function Career() {
  const experiences = [
    {
      id: 1,
      company: 'Trivana Hospitality',
      position: 'Chief Executive Officer',
      type: 'Full-time',
      duration: 'Apr 2025 - Present',
      period: '1 yr',
      location: 'Bikaner, Rajasthan, India · On-site',
      description: 'Developer & Founder at Trivana Hospitality, leading business operations and technical development.',
      skills: ['New Business Development', 'Entrepreneurship', 'Leadership'],
      current: true
    },
    {
      id: 2,
      company: 'Trivana Hospitality',
      position: 'Founder',
      type: 'Full-time',
      duration: 'Jan 2025 - Present',
      period: '1 yr 3 mos',
      location: 'Bikaner, Rajasthan, India',
      description: 'Founded and established Trivana Hospitality, focusing on hospitality services and technology integration.',
      skills: ['Business Strategy', 'Product Development', 'Team Management'],
      current: true
    },
    {
      id: 3,
      company: 'Future Intern',
      position: 'Intern',
      type: 'Part-time',
      duration: 'Apr 2025',
      period: '1 mo',
      location: 'Bikaner, Rajasthan, India · Remote',
      description: 'Worked on Machine Learning and Data Visualization projects, gaining hands-on experience in ML algorithms and data analysis.',
      skills: ['Machine Learning', 'Data Visualization', 'Python'],
      certificate: true
    },
    {
      id: 4,
      company: 'KRASHAK INNOVATIVE SOLUTION',
      position: 'Intern',
      type: 'Full-time',
      duration: 'Mar 2024 - Jan 2025',
      period: '11 mos',
      location: 'Bikaner, Rajasthan, India · On-site',
      description: 'Designed and developed a portable soil health testing device website, focusing on user-friendly interfaces and usability. Applied technical expertise in C, C++, and Python to deliver innovative solutions.',
      skills: ['C', 'C++', 'Python', 'Web Development', 'IoT'],
      certificate: true
    },
    {
      id: 5,
      company: 'GirlScript Summer of Code (GSSoC)',
      position: 'Open Source Contributor',
      type: 'Remote',
      duration: 'Oct 2024 - Nov 2024',
      period: '2 mos',
      location: 'Remote',
      description: 'Participated in GSSoC 2024, contributing to open-source projects. Enhanced skills in collaborative development and version control.',
      skills: ['GitHub', 'Open-Source Development', 'Git'],
      certificate: true
    },
    {
      id: 6,
      company: 'DevFest Ai',
      position: 'DevFest Participant',
      type: 'Remote',
      duration: 'Oct 2024 - Nov 2024',
      period: '2 mos',
      location: 'Remote',
      description: 'Participated in DevFest AI, exploring latest AI/ML technologies and contributing to web development projects.',
      skills: ['GitHub', 'Web Development', 'AI/ML'],
      certificate: true
    },
    {
      id: 7,
      company: 'Govt. Engineering College Bikaner',
      position: 'Hackathon - Team Lead',
      type: 'On-site',
      duration: 'Sep 2024',
      period: '1 mo',
      location: 'Bikaner, Rajasthan, India · On-site',
      description: 'Participated in a college campus hackathon and secured third position with team HackHounds. Developed a sports and fitness website from scratch.',
      skills: ['Full-Stack Development', 'Project Management', 'Team Leadership'],
      certificate: true
    },
    {
      id: 8,
      company: 'Mood Indigo, IIT Bombay',
      position: 'Contingent Leader',
      type: 'Remote',
      duration: 'Dec 2023',
      period: '1 mo',
      location: 'Remote',
      description: 'Awarded for remarkable performance as contingent leader for Mood Indigo 2023, IIT Bombay. Led team coordination and event management.',
      skills: ['Leadership', 'English', 'Event Management'],
      certificate: true
    }
  ];

  return (
    <section id="career">
      <p className="section__text__p1 outfit-semibold">Explore My</p>
      <h1 className="title playfair-display-bold">Career Journey</h1>
      <div className="career-container">
        <div className="timeline">
          {experiences.map((exp, index) => (
            <div 
              key={exp.id} 
              className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'} ${exp.current ? 'current' : ''}`}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="timeline-content">
                <div className="timeline-header">
                  <h3 className="outfit-semibold">{exp.position}</h3>
                  {exp.current && <span className="current-badge">Current</span>}
                </div>
                <div className="company-info">
                  <h4 className="outfit-medium">{exp.company}</h4>
                  <span className="job-type">{exp.type}</span>
                </div>
                <div className="timeline-meta">
                  <span className="duration">📅 {exp.duration}</span>
                  <span className="period">⏱️ {exp.period}</span>
                </div>
                <p className="location">📍 {exp.location}</p>
                <p className="description outfit-regular">{exp.description}</p>
                <div className="skills-tags">
                  {exp.skills.map((skill, idx) => (
                    <span key={idx} className="skill-tag">{skill}</span>
                  ))}
                </div>
                {exp.certificate && (
                  <div className="certificate-badge">📜 Certificate Earned</div>
                )}
              </div>
              <div className="timeline-dot"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Career;
